module.exports = "<div class=mobile-pwa-prompt ng-show=\"$ctrl.isIos() && !$ctrl.isPwa() && $ctrl.displayPrompt\"> <span class=mobile-pwa-prompt__label> <span ng-bind=\"'In Safari, tap'|translate\"></span> <svg class=mobile-pwa-prompt__arrow> <use xlink:href=#ios-arrow-up></use> </svg> <span ng-bind=\"'and then \\'Add to Homescreen\\''|translate\"></span> </span> <a class=mobile-pwa-prompt__icon-container ng-click=$ctrl.closePrompt()> <svg class=mobile-pwa-prompt__icon> <use xlink:href=#cross-icon></use> </svg> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/auth/modules/sign-in/components/pwa-prompt/pwa-prompt.html
// module id = 355
// module chunks = 0